import type { SupportedLocales } from '#shared/types/locales'

export const DRIVER_LICENSE_CLASS_BY_REGION: Record<string, string[]> = {
  AB: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '5-GDL',
    '6',
  ],
  BC: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
  ],
  MB: [
    '1',
    '2',
    '3',
    '4',
    '5F',
    'F1',
    'FL',
  ],
  NB: [
    '1',
    '2',
    '3',
    '4',
    '5',
  ],
  NL: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
  ],
  NS: [
    '1',
    '2',
    '3',
    '4',
    '5',
  ],
  NT: [
    '1',
    '2',
    '3',
    '4',
    '5',
  ],
  NU: [
    '1',
    '2',
    '3',
    '4',
    '5',
  ],
  ON: [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G1',
    'G2',
    'G',
  ],
  PE: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
  ],
  QC: [
    '1',
    '2',
    '3',
    '4',
    '5',
  ],
  SK: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '5-Novice 1',
    '5 Novice 2',
  ],
  YT: [
    '1',
    '2',
    '3',
    '4',
    '5',
  ],
} as const
Object.freeze(DRIVER_LICENSE_CLASS_BY_REGION)
export type DRIVER_LICENSE_CLASS_BY_REGION = (typeof DRIVER_LICENSE_CLASS_BY_REGION)[keyof typeof DRIVER_LICENSE_CLASS_BY_REGION]

/**
 * Pattern
 *
 * a - letter
 * A - Uppercase letter
 * x - Uppercase letter or number
 * # - any uppercase letter or asterisk (*)
 * 0 - number
 * [] - optional
 */
export const DRIVER_LICENSE_FORMAT_VALIDATION_BY_REGION: Record<string, {
  format: RegExp
  pattern: string
  placeholder: Record<SupportedLocales, string>
}> = {
  AB: {
    format: /^\d{1,9}$/,
    pattern: '0[0][0][0][0][0][0][0][0]',
    placeholder: {
      en: '999999999 (Maximum 9 digits)',
      fr: '999999999 (9 chiffres maximum)',
    },
  },
  BC: {
    format: /^\d{1,8}$/,
    pattern: '0[0][0][0][0][0][0][0]',
    placeholder: {
      en: '99999999 (Maximum 8 digits)',
      fr: '99999999 (8 chiffres maximum)',
    },
  },
  MB: {
    format: /^([A-Z])([A-Z*]{4})([A-Z])([A-Z*])([A-Z0-9]{2})(\d)([A-Z0-9]{2})$/,
    pattern: 'A####A#XX0XX',
    placeholder: {
      en: 'AKKKKAKXX9XX (12 characters)',
      fr: 'AKKKKAKXX9XX (12 caractères)',
    },
  },
  NB: {
    format: /^\d{1,7}$/,
    pattern: '0[0][0][0][0][0][0]',
    placeholder: {
      en: '9999999 (Maximum 7 digits)',
      fr: '9999999 (7 chiffres maximum)',
    },
  },
  NL: {
    format: /^([A-Z])(\d{9})$/,
    pattern: 'A000000000',
    placeholder: {
      en: 'A99999999 (10 characters)',
      fr: 'A99999999 (10 caractères)',
    },
  },
  NS: {
    format: /^([A-Z])([A-Z*]{4})(\d{9})$/,
    pattern: 'A####000000000',
    placeholder: {
      en: 'AKKKK999999999 (Maximum 14 characters)',
      fr: 'AKKKK999999999 (Maximum 14 caractères)',
    },
  },
  NT: {
    format: /^\d{1,6}$/,
    pattern: '0[0][0][0][0][0]',
    placeholder: {
      en: '999999 (Maximum 6 digits)',
      fr: '999999 (6 chiffres maximum)',
    },
  },
  NU: {
    format: /^\d{1,6}$/,
    pattern: '0[0][0][0][0][0]',
    placeholder: {
      en: '999999 (Maximum 6 digits)',
      fr: '999999 (6 chiffres maximum)',
    },
  },
  ON: {
    format: /^([A-Z])(\d{14})$/,
    pattern: 'A000000000000000',
    placeholder: {
      en: 'A999999999999999 (15 characters)',
      fr: 'A999999999999999 (15 caractères)',
    },
  },
  PE: {
    format: /^\d{1,7}$/,
    pattern: '0[0][0][0][0][0][0]',
    placeholder: {
      en: '999999 (Maximum 7 digits)',
      fr: '999999 (7 chiffres maximum)',
    },
  },
  QC: {
    format: /^([A-Z])(\d{10})([A-Z0-9])(\d)$/,
    pattern: 'A0000000000X0',
    placeholder: {
      en: 'A9999999999X9 (13 characters)',
      fr: 'A9999999999X9 (13 caractères)',
    },
  },
  SK: {
    format: /^\d{8}$/,
    pattern: '00000000',
    placeholder: {
      en: '99999999 (8 digits)',
      fr: '99999999 (8 chiffres)',
    },
  },
  YT: {
    format: /^\d{1,6}$/,
    pattern: '0[0][0][0][0][0]',
    placeholder: {
      en: '999999 (Maximum 6 digits)',
      fr: '999999 (6 chiffres maximum)',
    },
  },
} as const
Object.freeze(DRIVER_LICENSE_FORMAT_VALIDATION_BY_REGION)
export type DRIVER_LICENSE_FORMAT_VALIDATION_BY_REGION = (typeof DRIVER_LICENSE_FORMAT_VALIDATION_BY_REGION)[keyof typeof DRIVER_LICENSE_FORMAT_VALIDATION_BY_REGION]
